import { render, staticRenderFns } from "./ManageSelectedMessages.vue?vue&type=template&id=c16efc7e&scoped=true&lang=pug&"
import script from "./ManageSelectedMessages.vue?vue&type=script&lang=js&"
export * from "./ManageSelectedMessages.vue?vue&type=script&lang=js&"
import style0 from "./ManageSelectedMessages.vue?vue&type=style&index=0&id=c16efc7e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16efc7e",
  null
  
)

export default component.exports